import React, { useState, useEffect } from 'react'; // Importa useEffect

// Componente para mostrar el mensaje de éxito (traducido)
const Result = () => {
    return (
        <p className="success-message" style={{ color: 'green', marginTop: '15px' }}>
            {/* Mensaje indicando la redirección a WhatsApp */}
            Tu mensaje está listo para ser enviado por WhatsApp. Se abrirá una nueva pestaña.
        </p>
    );
};

// Componente del formulario
function ContactForm() { // No necesita props si no se usan
    const [result, showResult] = useState(false); // Estado para mostrar/ocultar el mensaje de éxito

    // Función que se ejecuta al enviar el formulario
    const handleSubmit = (e) => {
        e.preventDefault(); // Previene el comportamiento por defecto del formulario (recargar la página)

        // --- Obtener datos del formulario ---
        const form = e.target;
        const name = form.fullname.value;
        const email = form.email.value;
        const phoneInput = form.phone.value; // Teléfono ingresado por el usuario
        const subject = form.subject.value;
        const message = form.message.value;

        // --- Construir el mensaje para WhatsApp ---
        const messageBody = `Hola 👋, mi nombre es ${name}.\n\n*Asunto:* ${subject}\n*Correo:* ${email}\n*Teléfono:* ${phoneInput}\n\n*Mensaje:*\n${message}`;

        // --- Codificar el mensaje para la URL ---
        const encodedMessage = encodeURIComponent(messageBody);

        // --- Número de teléfono de destino (con código de país) ---
        const targetPhoneNumber = '584244560374'; // Tu número de WhatsApp

        // --- Construir la URL de WhatsApp ---
        const whatsappUrl = `https://api.whatsapp.com/send?phone=${targetPhoneNumber}&text=${encodedMessage}`;

        // --- Abrir WhatsApp en una nueva pestaña ---
        window.open(whatsappUrl, '_blank');

        // --- Limpiar el formulario ---
        form.reset();

        // --- Mostrar el mensaje de éxito ---
        showResult(true);
    };

    // --- Ocultar el mensaje de éxito después de 5 segundos ---
    // Se usa useEffect para manejar el temporizador correctamente
    useEffect(() => {
        let timer;
        if (result) {
            timer = setTimeout(() => {
                showResult(false);
            }, 5000); // 5000 milisegundos = 5 segundos
        }
        // Limpia el temporizador si el componente se desmonta o si result cambia a false antes de tiempo
        return () => clearTimeout(timer);
    }, [result]); // Este efecto se ejecuta cada vez que 'result' cambia

    return (
        // El atributo action ya no es necesario, onSubmit maneja todo
        <form onSubmit={handleSubmit}>
            <div className="rn-form-group">
                <input
                    type="text"
                    name="fullname"
                    placeholder="Nombre Completo" // Traducido
                    required
                />
            </div>

            <div className="rn-form-group">
                <input
                    type="email"
                    name="email"
                    placeholder="Correo Electrónico" // Traducido
                    required
                />
            </div>

            <div className="rn-form-group">
                <input
                    type="text" // Puedes cambiar a type="tel" para mejor semántica y UX móvil
                    name="phone"
                    placeholder="Número de Teléfono" // Traducido
                    required
                />
            </div>

            <div className="rn-form-group">
                <input
                    type="text"
                    name="subject"
                    placeholder="Asunto" // Traducido
                    required
                />
            </div>

            <div className="rn-form-group">
                <textarea
                    name="message"
                    placeholder="Tu Mensaje" // Traducido
                    required
                >
                </textarea>
            </div>

            <div className="rn-form-group">
                <button className="rn-button-style--2 btn-solid" type="submit" name="submit" id="mc-embedded-subscribe">
                    Enviar por WhatsApp {/* Texto del botón cambiado */}
                </button>
            </div>

            {/* Muestra el componente Result si el estado 'result' es true */}
            <div className="rn-form-group">
                {result ? <Result /> : null}
            </div>
        </form>
    );
}

export default ContactForm;